// extracted by mini-css-extract-plugin
export default {"root":"_3LIsf","badge":"_3lA9T","draft":"_3DNoo","pending-deletion":"DFjrZ","pendingDeletion":"DFjrZ","need-core":"_3Y_g1","needCore":"_3Y_g1"};